module.exports = __webpack_public_path__ + "img/91ne.b0dfb80f.svg";